import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios.ts';
import { type MutationConfig } from 'src/lib/react-query.ts';
import { formatResourcePath } from 'src/utils/regex.ts';

const RESOURCE = 'parkings/parking-gateways/:id/';

interface DTO {
    id: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ id }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { id }));
};

interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteParkingGateway };
export type { DTO as DeleteParkingGatewayDTO };
